import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import { DF_OT0011Context } from "../context";
import { Col, Row } from "reactstrap";
import TableSimple from "../../../components/Dynamic/TableSimple";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { isLoading } from "../../../store/layout/actions";
import DF_OT0011A from "../DF_OT0011A";
import ModalIframePage from "../../../components/Common/ModalIframePage";


function GridBodyFlowOne() {

  const dispatch = useDispatch(); 

  const [step, setStep] = useState(1);

  const { parseParams, csrfToken, access_token, userProfile } = useContext(DF_OT0011Context);
  const [openModal, setOpenModal] = useState(false);
  const [triggerType, setTriggerType] = useState([])

  const [preFilter, setPreFilter] = useState([]);
  const [listaPedidos, setlistaPedidos] = useState([])
  const [notasPesquisadas, setNotasPesquisadas] = useState(false)
  const [validacaoResults, setValidacaoResults] = useState([])
  const [validacaoExecutada, setValidacaoExecutada] = useState(false)
  const [notasSelecionadas, setNotasSelecionadas] = useState([])
  const [notasGrid, setNotasGrid] = useState([])

  const ID_DOCUMENTO_GRUPO = 2;

  const handleTriggers = (trigger) => {
    console.log("trigger", trigger)
    setOpenModal(true)
    setTriggerType(trigger)
  }

  const dataBRtoUS = (dataStr) => {
    if (!dataStr) return dataStr;
    const [dia, mes, ano] = String(dataStr).split("/");
    if (!dia || !mes || !ano) return dataStr;
    return `${mes}-${dia}-${ano}`;
  };

  const bloqueios = validacaoResults.filter(
    (v) => (v?.Tipo_Mensagem || "").trim().toUpperCase() === "E",
  );
  const semProblemas = validacaoResults.every((v) => {
    const tipo = (v?.Tipo_Mensagem || "").trim().toUpperCase();
    return tipo !== "E" && tipo !== "A" && tipo !== "W";
  });

  const canAdvance =
    notasSelecionadas.length > 0 &&
    validacaoExecutada &&
    bloqueios.length === 0;

  // NEW VERSION

  const handleGetDataStep3 = async () => {
    try {
      dispatch(isLoading(true));
      const params = {
        1: userProfile?.ID_Usuario,
        2: preFilter[0]?.["Filtro_ID_Local_Entrega"]?.value,
        3: dataBRtoUS(preFilter[0]?.["Filtro_Data_Inicio"]?.value),
        4: dataBRtoUS(preFilter[0]?.["Filtro_Data_Termino"]?.value),
        5: ID_DOCUMENTO_GRUPO,
        6: preFilter[0]?.["Filtro_ID_Empresa_Origem"]?.value,
      };
      const resp = await BizinBackend.executeProcedure(
        params,
        "SRM_Agendamentos_Get_Notas_Fiscais",
        csrfToken,
        access_token,
      );
      
      const rows = resp?.data || resp?.resultset_1 || (Array.isArray(resp) ? resp : []);
      setNotasGrid(Array.isArray(rows) ? rows : []);
      setNotasPesquisadas(true);
    } catch (e) {
      console.log("erro ao buscar notas", e);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleGetDataStep2 = async () => {    
    const destinoSelecionado = preFilter[0]?.["Filtro_ID_Empresa_Destino"]?.value;
    try {
      dispatch(isLoading(true));

      const resp = await BizinBackend.executeProcedure(
        { 
          1: userProfile.ID_Usuario,
          2: 'pt-BR',
          3: preFilter[0]?.["Filtro_ID_Empresa_Origem"]?.value,
          4: preFilter[0]?.["Filtro_ID_Empresa_Destino"]?.value,
          5: preFilter[0]?.["Filtro_ID_Local_Entrega"]?.value,
          6: preFilter[0]?.["Filtro_ID_Tipo_Frete"]?.value || 'CIF',
        },
        "FRONT_Workspace_DF_OT0011_Tabela_Grid",
        csrfToken,
        access_token,
      );

      if(resp && resp.length > 0) setlistaPedidos(resp);
      else setlistaPedidos([]);
    } catch (error) {
      console.log("erro ao carregar locais de entrega", error);
    } finally {
      dispatch(isLoading(false));
    }
  };

  const handleNextStep = async (nextStep) => {
    switch (nextStep) {
      case 2:
        await handleGetDataStep2();
        localStorage.setItem('Prefilters', JSON.stringify(preFilter));
        setStep(2);
        break;
      case 3:
        await handleGetDataStep3();
        setStep(3);
        break;
    }
  }


  return (
    <div className="vh-100 p-0">
      <div className="bg-white mb-3 card-content shadow-card p-4">
          <div className="row d-flex align-items-center">
            <div className="col-12 col-md-3 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Empresa_Origem"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Empresa Origem",
                  id: "Filtro_ID_Empresa_Origem",
                  isDisabled: false,
                  procedure: "FRONT_Componente_Combo_Empresas",
                  procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'ORIGEM', 'NF']
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-3 p-md-0 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Empresa_Destino"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Empresa Destino",
                  id: "Filtro_ID_Empresa_Destino",
                  isDisabled: false,
                  procedure: "FRONT_Componente_Combo_Empresas",
                  procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'DESTINO', 'NF'],
                  alienated: ["Filtro_ID_Empresa_Origem"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-3 p-md-0 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Local_Entrega"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Local de Entrega",
                  id: "Filtro_ID_Local_Entrega",
                  isDisabled: false,
                  procedure: "SRM_Agendamento_Local_Entrega",
                  procedureParams: [userProfile?.ID_Usuario, '<#Filtro_ID_Empresa_Destino#>'],
                  alienated: ["Filtro_ID_Empresa_Destino"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-3 ps-0 form-custom01-filter">
              <TranspaleStringToComponente
                elementId={"Filtro_Data_Prevista"}
                elementProps={{
                  value: "",
                  type: "Date",
                  title: "Data Prevista",
                  id: "Filtro_Data_Prevista"
                }}
                preFilter={preFilter}
                onPreFilter={(filters) =>
                  setPreFilter((state) => [{ ...state[0], ...filters }])
                }
              />
            </div>
            <div className="col pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Veiculo"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Veículo",
                  id: "Filtro_ID_Veiculo",
                  isDisabled: false,
                  procedure: "SRM_Get_Conhecimento_Transporte_Veiculos",
                  procedureParams: ['<#Filtro_ID_Empresa_Destino#>', '<#Filtro_ID_Local_Entrega#>'],
                  alienated: ["Filtro_ID_Empresa_Destino"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col p-md-0 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Tipo_Entrega"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Tipo de Entrega",
                  id: "Filtro_ID_Tipo_Entrega",
                  isDisabled: false,
                  procedure: "SRM_Agendamento_Get_Lista_Tipo_Entrega",
                  procedureParams: ['<#Filtro_ID_Empresa_Destino#>'],
                  alienated: ["Filtro_ID_Empresa_Destino"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col p-md-0 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Categoria"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Categoria",
                  id: "Filtro_ID_Categoria",
                  isDisabled: false,
                  procedure: "CUA_Get_Categorias_Parceria",
                  procedureParams: ['<#Filtro_ID_Empresa_Destino#>', `${preFilter[0]?.Filtro_ID_Empresa_Origem?.value}`],
                  alienated: ["Filtro_ID_Empresa_Destino", ]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-6 col pe-lg-3 ps-md-0 align-self-baseline" style={{width: 200}}>
              <label className="form-label mb-3">Tipo de Frete</label>
              <div className="d-flex gap-4">
                <div className="d-flex align-items-center">                           
                  <TranspaleStringToComponente
                    elementId={"ID_Tipo_Frete_FOB"}
                    elementProps={{
                      value: 'FOB',
                      type: 'Radio',
                      name: "Filtro_ID_Tipo_Frete",
                      id: "Filtro_ID_Tipo_Frete"
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
                  <span className="fw-regular text-color-cinza5 font-size-14">FOB</span>  
                </div>
                <div className="d-flex align-items-center">
                  <TranspaleStringToComponente
                    elementId={"ID_Tipo_Frete_CIF"}
                    elementProps={{
                      value: 'CIF',
                      type: 'Radio',
                      name: "Filtro_ID_Tipo_Frete",
                      id: "Filtro_ID_Tipo_Frete"
                    }}
                    preFilter={preFilter}
                    onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
                  />
                  <span className="fw-regular text-color-cinza5 font-size-14">CIF</span> 
                </div>
              </div>
            </div>
            <div className="row justify-content-end p-0">
              <div className="col-md-1 col d-flex mb-3 p-0">
                <button className="btn btn-primary-dark text-white font-size-16 fw-semibold w-100" onClick={() => handleNextStep(2)} >Pesquisar</button>
              </div>
            </div>
          </div>
      </div>
              
      <div style={{display: step === 2 ? 'block' : 'none'}} className="mt-4 row">
        <div className="col-12">
          <TableSimple
            dataKey={"ID_Arquivo"}
            data={listaPedidos}
            columnsList={[
              { field: "ID_Arquivo", header: "Id", sort: true },
              { field: "Numero_Pedido", header: "Pedido", sort: true },
              { field: "Nome_Empresa_Origem", header: "Origem", sort: true },
              { field: "Nome_Empresa_Destino", header: "Destino", sort: true },
              { field: "Data_Upload", header: "Dt.Envio", sort: true },
              { field: "Valor_Total_Pedido", header: "Valor do Pedido", sort: true },
              { field: "Coluna_Funcoes", hasImage: true, width: '2%', header: "", },
            ]}
            enableTotalRows
            callbackTriggers={handleTriggers}
          />
        </div>
        <div className="d-flex col justify-content-end my-3">
          <button className="btn btn-primary-dark text-white font-size-16 fw-semibold" onClick={() => {}} >Próximo</button>
        </div>
      </div>
      
      <ModalIframePage 
        openModal={openModal} 
        onClosed={() => setOpenModal(false)}
        triggerType={triggerType}
        />
    </div>
  )
}

export default GridBodyFlowOne;
